import { ReactNode } from 'react'

import { PageTitle } from '@apps-common/components/common/portal-title'
import { Breadcrumbs } from '@apps-common/components/navigation'
import { useManagementViewStore } from '@apps-common/stores/useManagementViewStore'
import { ROUTE_MANAGEMENT } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  search?: ReactNode
}

export const ManagementHeader = ({ search }: IProps) => {
  const { value: title } = useManagementViewStore()

  return (
    <>
      <Breadcrumbs route={ROUTE_MANAGEMENT} />
      <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-[10px] pb-[5px]'>
        <div className='flex items-center justify-start gap-[10px]'>
          <PageTitle>
            <span className='block capitalize'>{title}</span>
          </PageTitle>
        </div>
        {search}
      </div>
    </>
  )
}
